module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back005sp.e96983fe.webp";